import Vue from 'vue';
import VueRouter from 'vue-router';
// import store from '../store/';
// import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import HomeRouter from './home-router';
import WageRouter from './wage-router';
// import website from '@/config/website';
// import localStorage from '@/util/storage';
Vue.use(VueRouter);
// const originalPush = VueRouter.prototype.push;
// //修改原型对象中的push方法
// VueRouter.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch((err) => err);
// };
console.log("VueRouter", VueRouter);
//创建路由
export const createRouter = () =>
  new VueRouter({
    // mode: 'history',
    routes: [...HomeRouter, ...WageRouter]
  });

const router = createRouter();

// router.beforeEach((to, from, next) => {
//   NProgress.start();
//   console.log("beforeEach");
//   next();
//   // console.log('router', to.path);
//   // if (to.path.includes('/user/logout')) {
//   //   localStorage.removeLocal(website.UserInfoKey);
//   //   store.dispatch('user/clearUserInfo');
//   //   next();
//   // } else {
//   //   if (to.path.includes('/user/login')) {
//   //     console.log('router1', to);
//   //     if (to.meta && to.meta.requiresAuth) {
//   //       const state = store.state;
//   //       const user = state.user;
//   //       if (user.userInfo) {
//   //         next('/');
//   //       } else {
//   //         next();
//   //       }
//   //     } else {
//   //       next();
//   //     }
//   //   } else {
//   //     console.log('router2', to);
//   //     const state = store.state;
//   //     const user = state.user;
//   //     console.log('router2', user);
//   //     if (user.userInfo) {
//   //       next();
//   //     } else {
//   //       next('/user/login');
//   //     }
//   //   }
//   // }
// });

// router.afterEach(() => {
//   NProgress.done();
// });

export default router;
